module.exports = __webpack_public_path__ + "static/media/next2.56850392.svg";